import type { MapRegion } from "@/types"

export const sargonRegion: MapRegion = {
    id: "sargon",
    name: "map.region.sargon",
    mapImage: require("@/assets/imgs/map/sargon/map-sargon.png"),
    decoImage: require("@/assets/imgs/map/sargon/map-sargon-deco.png"),
    startNodeId: "sg-start",
    endNodeId: "sg-end",
    startDirection: "right",
    unlocked: true,
    order: 0,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-question-mark.png"),
            width: 181,
            height: 218,
        },
    },
    nodes: [
        {
            id: "sg-start",
            type: "start",
            level: 0,
            position: { x: 180, y: 500 },
            iconType: "question",
        },
        {
            id: "sg-passenger",
            type: "event",
            level: 1,
            position: { x: 327, y: 254 },
            eventId: "dlg-sg-passenger",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-event-passenger.png"),
                width: 210,
                height: 249,
            },
        },
        {
            id: "sg-evt1",
            type: "event",
            level: 1,
            position: { x: 394, y: 460 },
            eventId: "evt-sg-01",
            iconType: "question",
        },
        {
            id: "sg-pepe",
            type: "event",
            level: 1,
            position: { x: 502, y: 628 },
            eventId: "dlg-sg-pepe",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-event-pepe.png"),
                width: 208,
                height: 227,
            },
        },
        {
            id: "sg-evt3",
            type: "event",
            level: 2,
            position: { x: 726, y: 178 },
            eventId: "evt-sg-03",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-event-3.png"),
                width: 340,
                height: 297,
            },
        },
        {
            id: "sg-evt4",
            type: "event",
            level: 2,
            position: { x: 795, y: 401 },
            eventId: "evt-sg-04",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-event-4.png"),
                width: 374,
                height: 294,
            },
        },
        {
            id: "sg-evt2",
            type: "event",
            level: 2,
            position: { x: 1200, y: 604 },
            eventId: "evt-sg-02",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-event-2.png"),
                width: 377,
                height: 255,
            },
        },
        {
            id: "sg-end",
            type: "end",
            level: 3,
            position: { x: 1287, y: 190 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/sargon/map-sargon-target.png"),
                width: 176,
                height: 212,
            },
        },
    ],
    edges: [
        { from: "sg-start", to: "sg-passenger", waypoints: [] },
        { from: "sg-start", to: "sg-evt1", waypoints: [] },
        { from: "sg-start", to: "sg-pepe", waypoints: [{ x: 340, y: 628 }] },
        { from: "sg-passenger", to: "sg-evt3", waypoints: [] },
        { from: "sg-passenger", to: "sg-evt4", waypoints: [] },
        { from: "sg-pepe", to: "sg-evt2", waypoints: [] },
        { from: "sg-evt1", to: "sg-evt4", waypoints: [] },
        { from: "sg-evt2", to: "sg-end", waypoints: [] },
        { from: "sg-evt2", to: "sg-evt4", waypoints: [] },
        { from: "sg-evt3", to: "sg-evt4", waypoints: [] },
        { from: "sg-evt3", to: "sg-end", waypoints: [] },
        { from: "sg-evt4", to: "sg-end", waypoints: [] },
    ],
}
